import { RecallIntegrationService } from '../services/vault';

export const getCalls = async (): Promise<CallManagementItem[]> => {
  return dummy;
};
export const addAgentToConferenceCall = (data: any) => {
  return RecallIntegrationService.connectRecallConnectRecallPost(data);
};

export type CallManagementItemStatusType = 'finished' | 'ongoing' | 'planned';

export type CallManagementItem = {
  id?: string;
  background?: string;

  url: string;
  name: string;
  status: CallManagementItemStatusType;
};

const dummy: CallManagementItem[] = [
  {
    id: '1',
    name: 'First',
    url: 'https://www.google.com/',
    status: 'finished',
  },
  {
    id: '2',
    name: 'Second',
    url: 'https://www.google.com/',
    status: 'ongoing',
  },
  { id: '3', name: 'Third', url: 'https://www.google.com/', status: 'planned' },
  {
    id: '4',
    name: 'Forth',
    url: 'https://www.google.com/',
    status: 'finished',
  },
  { id: '5', name: 'Fifth', url: 'https://www.google.com/', status: 'planned' },
];

export type { ConnectRecallRequest } from '../services/vault';
